<template>
  <div class="section-statistics__tab section-statistics__tab--general">
    <StateBlock
      :isLoading="isLoading || !info"
      :isError="isError"
      :isEmpty="isEmpty"
      notFoundText="Нет данных"
    >
      <div class="wrapper spinner_block">
        <spinner
          v-if="activeLoading"
          position="relative"
          :size="25"
          :center="false"
        />
        <CustomButtonSelect
          :label="this.$t(`loyalty.controls.exportButton`)"
          :allow="!activeLoading"
          iconButton="export2"
          :options="selectOptions"
          @current="fileExport"
        />
      </div>

      <CirclesPart :value="info" />
      <h4 v-if="commType === 'email'" class="cm-title">
        (&#37; {{ $t("campaign.form.fromSent") }})
      </h4>
      <BarPart v-if="commType === 'email'" :value="rawInfo" />
    </StateBlock>
  </div>
</template>

<script>
import tabs_mixin from "@/components/statistics/stats/tabs/tabs_mixin";
// copypaste parts from tables_mixin
import StateBlock from "@/manzana_library/components/Widgets/StateBlock.vue";
import CirclesPart from "./CirclesPart.vue";
import BarPart from "./BarPart.vue";

import { formInfo } from "@/utils/statistics";
import { mapState, mapMutations } from "vuex";

import export_statistic_mixin from "@/components/statistics/export_statistic_mixin";

export default {
  mixins: [tabs_mixin, export_statistic_mixin],

  components: {
    CirclesPart,
    BarPart,
    StateBlock,
  },

  data() {
    return {
      keysConfig: {
        sms: ["sent", "uniqSent", "delivered", "uniqDelivered", "undelivered"],
        email: ["sent", "uniqSent", "delivered", "uniqDelivered", "opened", "clicked", "ctor", "unsubscribed", "softBounced", "hardBounced", "spam", "incorrectEmail"],
        viber: ["sent", "uniqSent", "delivered", "uniqDelivered", "opened", "clicked", "errors", "undelivered"],
        notification: ["sent", "uniqSent", "opened", "clicked", "errors"],
        promotions: ["uniqSent", "uniqDelivered"],
      },
    };
  },

  computed: {
    ...mapState({
      statDateRange: (state) => state.stat.statDateRange,
      rawInfo: (state) => state.stat.data.general.circles,
      isLoading: (state) => state.stat.loadings.general,
      isError: (state) => state.stat.errors.general,
    }),

    isEmpty() {
      return !Object.keys(this.rawInfo).length;
    },

    info() {
      if (this.isEmpty) return true;
      return formInfo(this.rawInfo, this.keysConfig[this.commType], !!this.$route.params.id);
    }
  },
  methods: {
    ...mapMutations({
      setGeneralCirclesData: "setGeneralCirclesData",
      statMutation: "statMutation"
    }),
  },
};
</script>

<style lang="scss">
.spinner_block {
  display: flex;
  width: 250px;
  margin-left: 80%;
  align-items: center;
}
.section-statistics__tab {
  max-width: auto;

  .cm-error-block {
    border: none;
    margin-top: 30px;
  }

  .cm-not-found {
    margin-top: 40px;
  }
}

.section-statistics__tab--general {
  max-width: 100% !important;

  .section-statistics__percentage-cards {
    max-width: 1380px;
  }
}

.cm-state-block {
  .wrapper {
    max-width: 100%;
    display: flex;
    justify-content: space-between;

    .cm-title {
      margin: 25px 0 20px 0;
    }
  }
}

</style>

<style lang="scss" scope>
.cm-state-block {
  .wrapper {
    height: 68px;
    position: relative;
    .custom-button-select {
      position: absolute;
      right: 0px;
      padding: 16px 0px;
    }
  }
}
</style>
